import React from 'react'
import Button from "@mui/material/Button";
import GroupsIcon from "@mui/icons-material/Groups";
import { connect } from "react-redux";
import { setSelectedServer } from "../../store/actions/roomActions";
import { setChosenChatDetails } from "../../store/actions/chatActions";

const MainPageButton = ({ setSelectedServer, setChosenChatDetails }) => {
  const handleClick = () => {
    setSelectedServer(null);
    setChosenChatDetails(null, null);
  };

  return (
    <Button onClick={handleClick} style={{width:"48px",
    height:"48px",
    borderRadius:"16px",
    margin:0,
    padding:0,
    minWidth:"0",
    marginTop:"10px",
    color:"white",
    backgroundColor:"#f97316"}} >

        <GroupsIcon/>
    </Button>
  )
}

export default connect(null, { setSelectedServer, setChosenChatDetails })(MainPageButton)
